import { State } from 'src/types'
import { hJointWeb, hWeb } from 'src/features/yellStory/drawer/glove/back/web/hWeb'
import { crossWeb } from 'src/features/yellStory/drawer/glove/back/web/crossWeb'
import { crossWebSingleKnot } from 'src/features/yellStory/drawer/glove/back/web/crossWebSingleKnot'
import { crossJointWeb, crossJointWebWithLace, crossWebWithLace } from 'src/features/yellStory/drawer/glove/back/web/crossWebWithLace'
import { vWebWithLace } from 'src/features/yellStory/drawer/glove/back/web/vWeb'
import { netWebDouble } from 'src/features/yellStory/drawer/glove/back/web/netWebDouble'
import { crossWebWithHalfNetLace, crossWebWithHalfNetLaceWithLace } from 'src/features/yellStory/drawer/glove/back/web/crossWebWithHalfLaceWeb'
import { jointCheckerWeb } from 'src/features/yellStory/drawer/glove/back/web/jointCheckerWeb'
import { yw14Web } from './yw14'
import { onePeaceWeb } from './onePeaceWeb'
import { joinOnePeaceWeb } from './jointOnePeaceWeb'
import { yw17Web } from './yw17'
import { reinforcementLace } from '../lace/reinforcementLace'
import { webDrawUtil } from 'src/util/canvas'

export const webOfGloveBackDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor } = webDrawUtil(state)

  if (['2B004G', 'SS061G', 'SS016G', '3B051G', 'BS004B', 'BS061B', '2B041JI'].includes(state.baseModel.productNumber)) {
    reinforcementLace(ctx, state.lace.color, 0, 0, 1, 1)
  }
  if (webMatcher(['Yw1', 'Yw10'])) crossWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw2'])) crossWebSingleKnot(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw3'])) crossWebWithLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw4'])) crossWebWithHalfNetLaceWithLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw5'])) crossJointWebWithLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw6'])) hWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw7'])) hJointWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw8'])) vWebWithLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw9'])) jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw11'])) crossWebWithHalfNetLace(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw12'])) crossJointWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw13'])) netWebDouble(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw14'])) yw14Web(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw15'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['Yw16'])) joinOnePeaceWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['Yw17'])) yw17Web(ctx, webColor, web2Color, laceColor, stitchColor)
}
